import {
  useEffect,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { Box, makeStyles, Typography, Grid } from "@material-ui/core";

import { getData } from "../../services";
import Menu from "../../components/menu/Menu";
import { HorizontalTabs } from "../../components/horizontalTabs";
import {
  InAGlanceTab,
  // PowerTab,
  PropertiesTab,
  TenantsTab,
  PortfolioOptimizationTab,
  // ValueAddedServicesTab
} from "./tabs";

const useStyles = makeStyles((theme) => ({
  rootContainer: {
    position: "relative",
  },
  root: {
    minHeight: "100vh",
    padding: `${theme.spacing(2.5)}px ${theme.spacing(4)}px`,
    marginLeft: theme.spacing(4.2),
    height: "100%",
    boxSizing: "border-box",
    flexGrow: 1,
    overflowX: "hidden",
  },
}));

export const BuildingAllPage = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);
  const navigate = useNavigate();
  const [buildings, setBuildings] = useState([]);
  const [complexes, setComplexes] = useState([]);
  const TabComponent = [
    InAGlanceTab,
    PortfolioOptimizationTab,
    PropertiesTab,
    TenantsTab,
    // PowerTab,
    // ValueAddedServicesTab,
  ][tab];
  const { cluster, segments, selectedCountries } = useSelector((state) => state.selectCSC);

  useEffect(() => {
    getData("/praas/v2/complexes/", setComplexes);
    getData("/praas/v2/buildings/without-complex/", setBuildings);
  }, [cluster, segments, selectedCountries]);

  return (
    <Grid className={classes.rootContainer} container>
      <Menu navigate={navigate} complexes={complexes} buildings={buildings} />

      <Box className={classes.root}>
        <Grid container>
          <Typography variant="h2" style={{ fontWeight: 400 }}>
            All Buildings
          </Typography>
        </Grid>

        <HorizontalTabs
          tab={tab}
          setTab={setTab}
          tabNames={[
            "At a Glance",
            "Portfolio Optimization",
            "Properties",
            "Tenants",
            // "Power Assets",
            // "Value Added Services",
          ]}
        />
        <TabComponent buildings />
      </Box>
    </Grid>
  );
};
